// Token de sesión en memoria (no en localStorage → no robable por XSS).
// La sesión real vive en una cookie HttpOnly que el backend fija en login.
// Este token en memoria solo se usa para las llamadas a naavi (otro subdominio que no
// recibe la cookie host-only); la única de naavi que requiere auth es customer-bookings.
let token: string | null = null;

export function setAuthToken(value: string | null): void {
  token = value && value.length ? value : null;
}

export function getAuthToken(): string {
  return token ?? "";
}

export function clearAuthToken(): void {
  token = null;
}
